/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Cell = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${Palette.PrimaryGray._700};
`;

export const EventCell = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 4px;
  font-size: 14px;
  color: ${Palette.PrimaryGray._700};

  div {
    white-space: nowrap;
  }
`;

export const CellInner = styled.div`
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
  user-select: none;
`;

export const Bid = styled.div`
  font-weight: 500;
  flex-shrink: 0;
  width: 90px;
  user-select: none;

  padding-left: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  span {
    font-weight: 400;
    color: ${Palette.PrimaryGray._500};
  }
`;

export const EventWrap = styled.div`
  display: flex;
  height: 100%;
  border-left: 1px solid ${Palette.PrimaryGray._200};
`;

export const ChangeBidBox = styled.div`
  margin-left: 3px;
  display: flex;
`;

export const BidIconButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  cursor: pointer;

  svg {
    fill: ${Palette.PrimaryGray._500};
    width: 12px;
    height: 12px;
    margin: auto 0;
  }

  &:hover {
    background-color: ${Palette.PrimaryGray._100};
    svg {
      fill: ${Palette.Primary._500};
    }
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.2;
      cursor: autol;
    `}
`;

export const TriggerBox = styled.div`
  display: flex;
  visibility: hidden;

  ${({ isOpen }) =>
    isOpen &&
    css`
      visibility: visible !important;
    `}
`;
